import QueueList from '../components/queue/QueueList';

const QueuePage = () => <QueueList />;

export default QueuePage;
